export const generateTimeArray = (is24H: boolean) => {
  const hoursArray = []
  if (is24H) {
    for (let i = 0; i < 24; i++) {
      hoursArray.push(`${i.toString().padStart(2, '0')}:00`)
    }
  } else {
    for (let i = 0; i < 24; i++) {
      const hour = i % 12 === 0 ? 12 : i % 12
      const suffix = i < 12 ? 'AM' : 'PM'
      hoursArray.push(`${hour} ${suffix}`)
    }
  }
  return hoursArray
}

export const calculateTimeBlock = (timeIn24Hour: string): number => {
  // Split the time string into hours, minutes, and seconds
  const timeParts = timeIn24Hour.split(':').map(Number)

  const totalMinutes = timeParts[0] * 60 + timeParts[1]
  
  // Calculate time block (30 minutes per block)
  const timeBlock = Math.floor(totalMinutes / 30)

  return timeBlock
}
